import React, { forwardRef } from 'react';

const HiddenFileInput = forwardRef(({
  onChange,
  accept,
  multiple = false,
  ...rest
}, ref) => {
  const handleChange = (event) => {
    onChange?.(event);
    event.target.value = '';
  };

  return (
    <input
      ref={ref}
      type="file"
      accept={accept}
      multiple={multiple}
      onChange={handleChange}
      style={{ display: 'none' }}
      {...rest}
    />
  );
});

HiddenFileInput.displayName = 'HiddenFileInput';

export default HiddenFileInput;
